import { CancelSubmitButtons } from "~/common/components";
import Modal, { ModalProps } from "~/common/components/Modal";
import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useDeleteSupplementalQuestion } from "~/providers/hooks/useDeleteSupplementalQuestion";
import { useSupplementalQuestionsEditorContext } from "./SupplementalQuestionsEditor";

interface DeleteSupplementalQuestionModalProps extends ModalProps {
  questionId: string;
}

export const DeleteSupplementalQuestionModal = ({
  questionId,
  ...props
}: DeleteSupplementalQuestionModalProps) => {
  const currentProvider = useCurrentTeamMemberContext();
  const { type } = useSupplementalQuestionsEditorContext();
  const { mutate: deleteQuestion, isPending } = useDeleteSupplementalQuestion();

  return (
    <Modal title="Delete question" className="xl:w-1/3" {...props}>
      <p>Are you sure you want to to delete this question?</p>
      <CancelSubmitButtons
        submitButtonLabel="Delete"
        handleSubmit={() =>
          deleteQuestion(
            {
              questionId,
              consultationType: type,
              organizationId:
                currentProvider.organization_team_members[0].organization_id,
            },
            {
              onSuccess: () => props.onClose(),
            },
          )
        }
        handleCancel={() => props.onClose()}
        isSubmitting={isPending}
        containerClassName="w-fit ml-auto"
        disableSubmit={isPending}
        disableCancel={isPending}
      />
    </Modal>
  );
};
